import { useState } from "react";
import SingleProgramMap from "../../../componnents/SingleProgramMap";

const Quartier = ({ location = null, position = null }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <section id="quartier" className="mt-70">
      <p className="semibold fs16 pink mb-10">Quartier</p>
      <div className="bg-white radius5 position-relative">
        <div
          className={!isActive ? "whiteLayer" : "whiteLayerhidden"}
          onClick={() => setIsActive(true)}
        >
          <img src="./icons/mapActivate.svg" alt="activate map" />
          <p className="fs20 bold darkGrey">Cliquer pour activer</p>
        </div>
        <div className="quartierMapContainer">
          {isActive && <SingleProgramMap programme={location?.[0] || null} />}
        </div>
      </div>
    </section>
  );
};

export default Quartier;
